<template>
  <div class="userinfo">
    <header-bar :name='"图片故事"'></header-bar>
    <div class="info_wrap">
      <div class="altas_info clearfix">
        <img :src="'https://collection2021-cos.chineseplus.net/'+picData.cover" alt="" class="cover" v-if="Object.keys(picData).length">
        <div class="info_con">
          <div class="title">{{picData.title}}</div>
          <div class="author">提供者：{{picData.user_name}}</div>
          <div class="country">所在国：{{picData.cn}}</div>
        </div>
      </div>
      <div class="picList clearfix">
        <van-swipe :initial-swipe="$route.query.index" @change="onChange">
          <van-swipe-item v-for="(v, i) in picData.photo_list" :key="i">
            <img :src="'https://collection2021-cos.chineseplus.net/'+v.photo_cover">
          </van-swipe-item>
        </van-swipe>
        <div class="desc">
          {{desc}}
        </div>
      </div>
    </div>
    <!-- <div class="bottom_con">
      <div class="result" v-show="resultShow">
        <img src="../img/m/refresh.png" alt="" class="refresh" @click="$router.go(0)">
        <div class="plus">
          <img src="../img/m/zan.png" alt="">
          <span>+1</span>
        </div>
        <div class="tip">您的选票已进入后台审核，稍后请刷新查看最新票数</div>
      </div>
      <div class="vote_con">
        <div class="num_con">
          <img src="../img/m/zan.png" alt="">
          <span class="num">{{picData.boost_num}}</span>
        </div>
        <div class="vote_btn" @click="zanFun()">投票</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Notify } from 'vant'
import {mapGetters, mapActions} from 'vuex'
import headerBar from '../common/headerBar'

export default {
  components: {
    headerBar
  },
  data () {
    return {
      picData: {},
      resultShow: false,
      desc: ''
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.getworkInfo()
  },
  methods: {
    getworkInfo () {
      this.$utils.get('/works/get-history-info', {works_id: this.$route.query.id}).then(res => {
        if (res.code == 1000) {
          this.picData = res.data
          this.desc = this.picData.photo_list[0].photo_desc
        }
      })
    },
    zanFun () {
      this.$utils.postForm('/vote/api/boostWorks', {works_id: this.$route.query.id}).then(res => {
        if (res.code == 1000) {
          this.resultShow = true
        } else {
          Notify({ type: 'warning', message: '未登录' })
          setTimeout(() => {
            this.loginFun()
          }, 2000)
        }
      })
    },
    onChange (i) {
      this.desc = this.picData.photo_list[i].photo_desc
    }
  }
}
</script>

<style lang="scss">
.van-swipe {
  padding-bottom: 1rem;
  .van-swipe__indicators {
    .van-swipe__indicator {
      background-color: #cabaf7;
    }
    .van-swipe__indicator--active {
      background-color: #9576ef;
      width: .36rem;
      border-radius: .09rem;
    }
  }
}
</style>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .info_wrap {
    padding: .28rem .44rem 0;
    .altas_info {
      background: #fff;
      padding: .3rem .35rem;
      .cover {
        width: 3.54rem;
        display: block;
        float: left;
      }
      .info_con {
        float: left;
        padding-left: .38rem;
        .title {
          font-size: .8rem;
          color: #282828;
          margin-bottom: .35rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .author {
          font-size: .48rem;
          color: #666;
        }
        .country {
          font-size: .48rem;
          color: #666;
          margin-top: .15rem;
        }
      }
    }
    .picList {
      padding: .25rem .35rem;
      padding-bottom: 0;
      background: #fff;
      margin-top: .3rem;
      height: calc(100vh - 5.5rem);
      img {
        display: block;
        // float: left;
        // width: 100%;
        height: 8rem;
        margin: auto;
      }
      .desc {
        font-size: .48rem;
        color: #666;
        line-height: 1.5;
        margin-top: .1rem;
      }
    }
  }
  .bottom_con {
    position: fixed;
    bottom: 0;
    width: 100%;
    .result {
      background-color: #f64109;
      position: relative;
      text-align: center;
      padding-top: 1.28rem;
      padding-bottom: .9rem;
      .refresh {
        position: absolute;
        right: .6rem;
        top: .45rem;
        width: .8rem;
      }
      .plus {
        img {
          width: 1.2rem;
          vertical-align: middle;
          margin-right: .2rem;
        }
        span {
          font-size: 1.34rem;
          color: #fff;
          vertical-align: middle;
        }
      }
      .tip {
        font-size: .48rem;
        color: rgba(255,255,255,.6);
        margin-top: 1.26rem;
      }
    }
    .vote_con {
      height: 2.38rem;
      .num_con {
        float: left;
        height: 2.38rem;
        width: calc(100% - 5.3rem);
        line-height: 2.3rem;
        background-color: #000000;
        img {
          width: 1.2rem;
          margin-right: .6rem;
          margin-left: .5rem;
        }
        .num {
          font-size: 1.34rem;
          color: #fff;
        }
      }
      .vote_btn {
        float: right;
        height: 2.38rem;
        background-color: #f64109;
        font-size: .8rem;
        color: #fff;
        text-align: center;
        line-height: 2.3rem;
        width: 5.3rem;
      }
    }
  }
}
</style>
